module.exports = __webpack_public_path__ + "static/media/Calendar.6fe0e46b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/CarEditorPage/components/changeCarData/components/EditCarInformation/img/Calendar.svg
// module id = 1720
// module chunks = 0